var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxisBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_20722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0112 1.00195C10.9624 2.60149 11.9219 4.19633 12.8629 5.80192C11.342 8.42796 9.843 11.0668 8.27058 13.6639C7.66728 14.6609 7.08045 15.6672 6.48402 16.6675C4.54989 16.6789 2.61577 16.6783 0.681641 16.6756C0.740666 16.5459 0.799006 16.4156 0.870386 16.292C3.91571 11.1944 6.9727 6.10355 10.0112 1.00195Z",
    fill: "#AE285D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75391 10.7505C11.6949 10.7498 13.6359 10.7364 15.5769 10.7679C16.7327 12.7403 17.9256 14.6912 19.0711 16.669C17.1301 16.6784 15.1898 16.671 13.2488 16.6697C12.0937 14.6905 10.8871 12.7417 9.75391 10.7505Z",
    fill: "#AE285D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_20722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisBank);
export default __webpack_public_path__ + "static/media/axis-bank.be30154078cb883ca1500b7c07b1e1b4.svg";
export { ForwardRef as ReactComponent };